export default __webpack_public_path__ + "static/media/tee2.4be9fe1e.webp";